import { computed } from "vue";

export default {
  name: "UtilMixin",
  data() {
    return {
      moneyConfig: {
        decimal: ',',       // Separador decimal
        thousands: '.',     // Separador de milhares
        prefix: '',      // Prefixo da moeda
        suffix: '',         // Sufixo (não usado aqui)
        precision: 2,       // Número de casas decimais
        masked: false       // Se true, o valor é mantido como string formatada
      }
    }
  },
  methods: {
    formattedMessageAlert(mensagem) {
      let formattedMessage = mensagem.split('<br>').join('\n');
      formattedMessage = formattedMessage.split('\\n').join('\n');
      return formattedMessage;
    },
    isProduction() {
      return process.env.NODE_ENV === "production";
    },
    formatarMoedaUSA(valor) {
      if (!valor) return '';
      if (typeof valor === 'number') return valor;
      return valor.replace(/\./g, '').replace(',', '.'); // Remove os pontos e substitui a vírgula por ponto;
    },
    formatarMoedaBRL(valor) {
      if (!valor) return '';
      return new Intl.NumberFormat('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(valor);
    },
  },
  computed: {
    ambiente() {
      return process.env.VUE_APP_AMBIENTE
    }, 
    getVersion() {
      return PACKAGE_VERSION;
    },
  },
};